<template>
  <v-container grid-list-xl>
    <v-layout column v-if="Info && Info.active">
      <v-flex v-if="Info">
        <div v-if="$vuetify.breakpoint.xsOnly">
          <div class="text-center mt-4">
            <img v-if="Info.Business.imageUrl" height="50" :src="Info.Business.imageUrl" alt="Logo" />
            <div class="text-h5" v-if="Info.Business.name">{{ Info.Business.name }}</div>
            <div v-if="Info.Business.phoneNumber">
              {{ Info.Business.phoneNumber | USPhoneNumber }}
            </div>
            <div>
              <span v-if="Info.Business.address">{{ Info.Business.address }}</span>, <span v-if="Info.Business.city">{{
                Info.Business.city
                }}</span>, <span v-if="Info.Business.state">{{ Info.Business.state }}</span>
              <span v-if="Info.Business.zip">{{ Info.Business.zip }}</span>
            </div>
          </div>
        </div>

        <div v-else>
          <v-layout class="mt-4 mx-2 mr-4" align-content-space-between row wrap>
            <v-flex>
              <img v-if="Info.Business.imageUrl" height="100" :src="Info.Business.imageUrl" alt="Logo" />
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex>
              <div class="text-right">
                <div class="text-h5" v-if="Info.Business.name">{{ Info.Business.name }}</div>
                <div>
                  <span v-if="Info.Business.address">{{ Info.Business.address }}</span>, <span
                    v-if="Info.Business.city">{{
                      Info.Business.city
                    }}</span>, <span v-if="Info.Business.state">{{ Info.Business.state }}</span>
                  <span v-if="Info.Business.zip">{{ Info.Business.zip }}</span>
                </div>
                <div v-if="Info.Business.phoneNumber">
                  {{ Info.Business.phoneNumber | USPhoneNumber }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex v-if="Info">
        <div class="black--text text-h4 font-weight-bold">
          {{ Info.name }}
        </div>
        <v-layout row wrap>
          <v-flex xs12 md8>
            <v-layout column>
              <v-flex>
                <v-card class="mx-auto rounded-xl">
                  <v-img contain :src="Info.imageUrl"></v-img>
                </v-card>
              </v-flex>
              <v-flex>
                <v-divider></v-divider>
                <div class="py-5"> Created {{ Info.createdAt | moment("from", "now") }}</div>
                <v-divider></v-divider>
              </v-flex>
              <v-flex>
                <div v-html="Info.description"></div>
              </v-flex>
            </v-layout>

          </v-flex>
          <v-flex xs12 md4>
            <v-card class="rounded-xl">
              <v-card-text>
                <v-layout column>
                  <v-flex>
                    <div>Contribution</div>
                    <span class="text-h4 black--text font-weight-light">{{ Info.amount | currency }}</span>
                  </v-flex>
                  <v-flex>
                    <v-progress-linear :value="reservationProgress"></v-progress-linear>
                    <!-- <v-progress-linear :value="reservationProgress" color="blue" height="20">
                    </v-progress-linear> -->
                    <div>{{ Info.submitCount }} Reservation</div>
                    <div>25 Seats</div>
                  </v-flex>

                  <v-flex>
                    <v-btn block large class="rounded-lg" @click="signUpNow" color="success">Reserve Now</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

          </v-flex>
        </v-layout>




      </v-flex>
    </v-layout>
    <v-layout row v-else-if="Info">
      <v-flex sm4>
        <lottie
          :options="defaultOptions"
          v-on:animCreated="handleAnimation"
        />
      </v-flex>
      <v-flex sm4>
        <v-card-text>
          <h2 class="display-1">This Link has Expired</h2>
          <span class="caption mt-2"
            >Please contact customer support to receive a new URL</span
          >
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
  <!-- <div>
    <v-card v-if="notFound" flat>
      <v-card-text>
        <v-card-text>
          <div class="text-center title">This link is expire.</div>
        </v-card-text>
      </v-card-text>
    </v-card>

    <div v-else>
      <v-card class="mx-auto" flat max-width="600">

        <div class="text-center mt-4" v-if="Info">
          <img v-if="Info && Info.Info.Business && Info.Info.Business.imageUrl" height="50" :src="Info.Info.Business.imageUrl"
            alt="Logo" />

          <div class="text-h5">{{ Info.Info.Business.name }}</div>
          <div>{{ Info.Info.Business.phoneNumber }}</div>
        </div>


        <div outlined class="mt-5">
          <v-card-text>
          
            <v-row v-if="Info">
              <v-col v-if="Info && Info.imageUrl">
                <v-img contain height="150" :src="Info.imageUrl" v-if="Info.imageUrl" />
              </v-col>
              <v-col cols="12">
                <h1>{{ Info.name }}</h1>
              </v-col>
              <v-col cols="12">
                <div v-html="Info.description"></div>
              </v-col>
              <v-col cols="12">
                <v-btn block large class="rounded-lg" @click="signUpNow" color="success">Sign up now</v-btn>
              </v-col>

            </v-row>
            
          </v-card-text>
          
        </div>


        <v-card-actions>
          <div class="text-right">
            Power by: <span>taleem.app</span> -
            <span class="caption">{{ version }}</span>
          </div>
        </v-card-actions>
      </v-card>


    </div>


  </div> -->
</template>
<!-- <script src="https://js.stripe.com/v3/"></script> -->
<script>
import EventDataService from "@/modules/Events/service.js";

import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/pinjump.json";

const pjson = require("../../../../package.json");




export default {
  name: "event-info",
  data() {
    return {
      EventDataId: null,
      EventData: {
        name: null,
        email: null,
        age: null,
        phoneNumber: null,
      },
      loading: false,
      defaultOptions: { animationData: animationData.default },
      notFound: false,
      showValue: false,
      cardCollected: false,
      Info: null,
    };
  },

  created() {
    this.loadData();
  },

  components: {
    Lottie
  },

  computed: {
    reservationProgress() {
      // Ensure the percentage doesn't exceed 100%
      return Math.min((this.Info.submitCount / 25) * 100, 100);
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.EventData.email.$dirty) return errors;
      if (!this.$v.EventData.email.required) errors.push("Email address is required");
      if (!this.$v.EventData.email.email) errors.push("Email is not valid");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.EventData.PhoneNumber.$dirty) return errors;
      if (!this.$v.EventData.PhoneNumber.required)
        errors.push("Phone Number is required");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.EventData.name.$dirty) return errors;
      if (!this.$v.EventData.name.required) errors.push("Name is required");
      return errors;
    },
    dobError() {
      const errors = [];
      if (!this.$v.EventData.dob.$dirty) return errors;
      if (!this.$v.EventData.dob.required)
        errors.push("Date of birth is required");
      return errors;
    },
    version() {
      return pjson.version;
    },
  },
  methods: {
    signUpNow() {
      this.$router.push({ path: `/e/${this.EventDataId}/apply` });
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    loadData() {
      let id = this.$route.params.id;

      return EventDataService
        .getPublicEventById(id)
        .then((response) => {
          console.log("response new", id, response);
          if (response.data) {
            this.Info = response.data;
            this.EventDataId = this.Info.id
            // this.StripeKey = this.Info.Info.Business.metadata.publicStripeId;
            // this.cardCollected = this.Info.isCollected;
            document.title = this.Info.Info.Business.name;
          } else {
            // console.log("asdkfjaslkdfjlaksjdf;lkasjdf");
            this.notFound = true;
          }

          // this.Donor = response.data;
          // console.log('response.data.alert', response)
          // if (response.data && !response.data.alert) response.data.alert = false
          this.$Progress.finish();
        })
        .catch(() => {
          this.loading = false
          this.$Progress.finish();
        });
    },
  },
};
</script>

<style scoped></style>